import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { FiArrowRight } from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

const EMPTY_SEGMENT = [{ name: '—', value: 100, color: '#E5E7EB' }];

export const ActivityBreakdown = ({ data, isLoading = false }) => {
  const { totalTime, label, segments } = data || {
    totalTime: '—',
    label: '—',
    segments: EMPTY_SEGMENT,
  };

  return (
    <div
      className={styles.chartCardMedium}
      style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
    >
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>Activity Breakdown</span>
      </div>

      <div className={styles.breakdownWrapper}>
        <div className={styles.breakdownChartArea}>
          <ResponsiveContainer width={160} height={160}>
            <PieChart>
              <Pie
                data={segments}
                cx="50%"
                cy="50%"
                innerRadius={66}
                outerRadius={76}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
                strokeWidth={0}
              >
                {segments.map((seg) => (
                  <Cell key={seg.name} fill={seg.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className={styles.breakdownCenter}>
            <div className={styles.breakdownCenterValue}>{totalTime}</div>
            <div className={styles.breakdownCenterLabel}>{label}</div>
          </div>
        </div>

        <div className={styles.breakdownLegend}>
          {segments.map((seg) => (
            <div key={seg.name} className={styles.legendItem}>
              <div
                className={styles.legendDot}
                style={{ backgroundColor: seg.color }}
              />
              <span className={styles.legendRowName}>{seg.name}</span>
              <span className={styles.legendRowValue}>{seg.value}%</span>
            </div>
          ))}
        </div>
      </div>

      <button className={styles.viewLink}>
        View full timeline <FiArrowRight size={13} />
      </button>
    </div>
  );
};
